export const loungeDetailsProductLabelClasses =
  'tw-inline-flex tw-font-features-off tw-text-base tw-not-italic tw-leading-6 tw-text-link md_tw-text-base';

export const policyButtonIds = {
  desktop: {
    access: 'access-policy-desktop',
    guest: 'guest-policy-desktop',
  },
  mobile: {
    access: 'access-policy-mobile',
    guest: 'guest-policy-mobile',
  },
};
